import React from 'react';
import { getMediaUrl } from './mediaUrl';

const AV1_TYPE = 'video/mp4; codecs="av01.0.08M.08"';

// Safari only reports AV1 when the device has a hardware decoder (iPhone 15 Pro+, M3+)
const canPlayAv1 = (() => {
  try {
    return document.createElement('video').canPlayType(AV1_TYPE) === 'probably';
  } catch {
    return false;
  }
})();

const PIPELINE_VIDEO = /\.h264\.mp4$/;

/**
 * <source> children for a <video>: the AV1 encode first (when this browser can
 * decode it), then the H.264 file. If the AV1 file isn't ready yet the browser
 * falls through to the next source. Give the <video> a `key` tied to the URL so
 * it reloads when the media changes.
 */
export function videoSources(url, fragment = '') {
  const src = getMediaUrl(url);
  const sources = [];
  if (canPlayAv1 && PIPELINE_VIDEO.test(src)) {
    sources.push(
      <source key="av1" src={`${src.replace(PIPELINE_VIDEO, '.av1.mp4')}${fragment}`} type={AV1_TYPE} />
    );
  }
  sources.push(<source key="h264" src={`${src}${fragment}`} />);
  return sources;
}

export default videoSources;
